	export enum ImportResultErrorTypeEnum {
		BadFileFormat = 1,
		ImportError = 2
	}
